// UUID pattern: hexadecimal characters with dashes
export const uuidPattern = '[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}';

export function isUUID(str: string) {
  const successPattern = new RegExp(`^${uuidPattern}$`, 'i');

  return successPattern.test(str);
}
